import React from "react";
import "../css/Cart.css";

// items: [{ item: <producto>, cantidad: number }]
const Cart = ({ items, onUpdateCantidad, onRemove, onEjecutar }) => {
  const total = items.reduce(
    (acc, entry) => acc + Number(entry.item.PRECIO) * entry.cantidad,
    0
  );

  if (items.length === 0) {
    return (
      <div className="cart-container cart-empty">
        <p>El carrito está vacío. Buscá un producto y agregalo desde el botón "Agregar".</p>
      </div>
    );
  }

  return (
    <div className="cart-container">
      <div className="cart-header">
        <h3>Carrito</h3>
        <span className="cart-count">
          {items.length} {items.length === 1 ? "producto" : "productos"}
        </span>
      </div>

      <div className="cart-list">
        {items.map((entry) => (
          <div key={entry.item.CLAVE} className="cart-row">
            <div className="cart-row-info">
              <div className="cart-row-nombre">{entry.item.NOMBRE}</div>
              <div className="cart-row-presentacion">{entry.item.PRESENTACION}</div>
            </div>

            <div className="cart-row-qty">
              <button
                type="button"
                onClick={() => onUpdateCantidad(entry.item.CLAVE, entry.cantidad - 1)}
                disabled={entry.cantidad <= 1}
                aria-label="Restar cantidad"
              >
                −
              </button>
              <span className="cart-row-qty-value">{entry.cantidad}</span>
              <button
                type="button"
                onClick={() => onUpdateCantidad(entry.item.CLAVE, entry.cantidad + 1)}
                aria-label="Sumar cantidad"
              >
                +
              </button>
            </div>

            <div className="cart-row-subtotal">
              ${(Number(entry.item.PRECIO) * entry.cantidad).toFixed(2)}
            </div>

            <button
              type="button"
              className="cart-row-remove"
              onClick={() => onRemove(entry.item.CLAVE)}
              aria-label="Eliminar producto"
            >
              ✕
            </button>
          </div>
        ))}
      </div>

      <div className="cart-footer">
        <div className="cart-total">
          Total: <strong>${total.toFixed(2)}</strong>
        </div>
        <button type="button" className="cart-ejecutar" onClick={onEjecutar}>
          Enviar pedido por WhatsApp
        </button>
      </div>
    </div>
  );
};

export default Cart;
